import axios from 'axios';

import { CONFIGURACION_MEMBRESIAS, CONFIGURACION_PERFIL, CONFIGURACION_REGIMENES_FISCALES, CONFIGURACION_GIROS } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* Membresias */
export const buscarMembresiasConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_membresias`, config);

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.BUSCAR,
            payload: res.data.membresias
        });
    } catch (error){ 
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const crearMembresiaConfiguracion = (membresia) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(membresia);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/crear_membresia`, body, config);

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.AGREGAR,
            payload: res.data.membresia
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerMembresiaConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_membresia`, body, config);

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.DETALLES,
            payload: res.data.membresia
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarMembresiaConfiguracion = () => dispatch => {
    dispatch({
        type: CONFIGURACION_MEMBRESIAS.DETALLES,
        payload: null
    });
}

export const editarMembresiaConfiguracion = (membresia) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(membresia);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_membresia`, body, config);

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.EDITAR,
            payload: res.data.membresia
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const eliminarMembresiaConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_membresia`, body, config);

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Regimenes fiscales */
export const buscarRegimenesFiscalesConfiguracion = (tipo_persona) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        tipo_persona
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_regimenes_fiscales`, body, config);

        await dispatch({
            type: CONFIGURACION_REGIMENES_FISCALES.BUSCAR,
            payload: res.data.regimenes
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Giros */
export const buscarGirosConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_giros`, config);

        await dispatch({
            type: CONFIGURACION_GIROS.BUSCAR,
            payload: res.data.giros
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

/* Perfil */
export const guardarPerfil = (perfil) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_perfil_personal`, perfil, config);

        await dispatch({
            type: CONFIGURACION_PERFIL.EDITAR_PERSONAL,
            payload: res.data.perfil
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}
